(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-block')) {
    customElements.define('accordion-block', class ScrollToSection extends HTMLElement {
      constructor() {
        super();

        this.isOpen = this.getAttribute('data-open') === 'true';
        this.autoClose = this.getAttribute('data-auto-close') === 'true';
        this.summary = this.querySelector('.accordion-block__summary:not([data-show-control="false"])');
        this.summaryButton = this.summary?.querySelector('button');
      }

      connectedCallback() {
        if (this.isOpen && this.autoClose) this.open();

        this.summary?.addEventListener('click', () => {
          this.isOpen = this.getAttribute('data-open') === 'true';
          if (this.isOpen) {
            this.close();
          } else {
            this.open();
          }
        });

        // open on enter click if button is in focus
        this.summaryButton?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.isOpen = this.getAttribute('data-open') === 'true';
            if (this.isOpen) {
              this.close();
            } else {
              this.open();
            }
          }
        });
      }

      open() {
        if (this.autoClose) {
          document.querySelectorAll('accordion-block[data-auto-close="true"][data-open="true"]').forEach((accordion) => {
            if (accordion !== this) accordion.close();
          });
        }

        this.setAttribute('data-open', 'true');
        this.summaryButton?.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.setAttribute('data-open', 'false');
        this.summaryButton?.setAttribute('aria-expanded', 'false');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get("ua-breadcrumbs")) {
    window.customElements.define(
      "ua-breadcrumbs",
      class UABreadcrumbs extends HTMLElement {
        constructor() {
          super();

          this.localStorageKey = "ua-breadcrumbs";

          window.addEventListener("DOMContentLoaded", () => {
            const isProductPage = window.location.href.includes("/products/");

            if (isProductPage) {
              const previousURL = document.referrer;
              if (previousURL && previousURL.includes("/collections/")) {
                this.addCollectionBreadcrumb();
              } else {
                this.removePreviousBreadcrumbs();
              }
            }

            document.querySelectorAll('a[href*="/products/"]').forEach((item) => {
              item.addEventListener("click", (event) => {
                localStorage.removeItem(this.localStorageKey);
              });
            });

            document.querySelectorAll('#product-grid a[href*="/products/"]').forEach((item) => {
              removeEventListener("click", this);
              item.addEventListener("click", (event) => {
                this.saveBreadcrumbs();
              });
            });
          });
        }

        removePreviousBreadcrumbs() {
          localStorage.removeItem(this.localStorageKey);
        }

        saveBreadcrumbs() {
          const currentURL = window.location.href;
          const pageTitle = this.cleanTitle(document.querySelector("h1.collection-hero__title")?.textContent || "");

          if (currentURL.includes("/collections/")) {
            this.removePreviousBreadcrumbs();

            const breadcrumbs = {
              collection: {
                title: pageTitle,
                url: currentURL,
              },
            };

            localStorage.setItem(this.localStorageKey, JSON.stringify(breadcrumbs));
          }
        }

        cleanTitle(title) {
          return title
            .replace(/[\r\n]+/g, "")
            .replace(/^Collection:\s+/i, "")
            .trim()
            .replace(/Collection:\s+/i, "");
        }

        addCollectionBreadcrumb() {
          const previousCollection = localStorage.getItem("ua-breadcrumbs");

          if (previousCollection) {
            const breadcrumbs = JSON.parse(previousCollection);
            const { title, url } = breadcrumbs.collection;
            if (title && url) {
              const ulElement = this.querySelector("ul, ol");

              if (ulElement) {
                const previousURL = document.referrer;

                if (previousURL && previousURL.includes("/products/")) {
                  // Don't add the element if the previous URL has 'products' in it
                  return;
                }

                const firstLiElement = ulElement.querySelector("li:first-child");
                const liElement = document.createElement("li");
                const aElement = document.createElement("a");

                liElement.classList.add("breadcrumbs__item");

                aElement.href = url;
                aElement.classList.add("breadcrumbs__link");
                aElement.textContent = title;

                if (firstLiElement) {
                  ulElement.insertBefore(liElement, firstLiElement.nextSibling);
                } else {
                  ulElement.appendChild(liElement);
                }

                liElement.appendChild(aElement);
              }
            }
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pickup-availability')) {
    customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if(!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = "";
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

        const button = this.querySelector('button');
        if (button) button.addEventListener('click', (evt) => {
          document.querySelector('pickup-availability-drawer').show(evt.target);
        });
      }
    });
  }

  // trapFocus/removeTrapFocus are read from the global.js plain script -
  // not moved into a javascript block, so they remain genuine globals.
  if (!customElements.get('pickup-availability-drawer')) {
    customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if(event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    // trapFocus/removeTrapFocus are read from the global.js plain script -
  // not moved into a javascript block, so they remain genuine globals.
  if (!customElements.get('cart-notification')) {
    customElements.define('cart-notification', class CartNotification extends HTMLElement {
      constructor() {
        super();

        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
          closeButton.addEventListener('click', this.close.bind(this))
        );
      }

      open() {
        this.notification.classList.add('animate', 'active');
        if (this.activeElement) this.activeElement.setAttribute('aria-expanded', 'true');

        this.notification.addEventListener('transitionend', () => {
          this.notification.focus();
          trapFocus(this.notification);
        }, { once: true });

        document.body.addEventListener('click', this.onBodyClick);
      }

      close() {
        this.notification.classList.remove('active');
        if (this.activeElement) this.activeElement.setAttribute('aria-expanded', 'false');
        document.body.removeEventListener('click', this.onBodyClick);

        removeTrapFocus(this.activeElement);
      }

      renderContents(parsedState) {
          this.cartItemKey = parsedState.key;
          this.getSectionsToRender().forEach((section => {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }));

          if (this.header) this.header.reveal();
          this.open();
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-notification-product',
            selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
          },
          {
            id: 'cart-notification-button'
          },
          {
            id: 'cart-icon-bubble'
          }
        ];
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
          const disclosure = target.closest('details-disclosure, header-menu');
          this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
          this.close();
        }
      }

      setActiveElement(element) {
        this.activeElement = element;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["data-statistics"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get("data-statistic")) {
    window.customElements.define("data-statistic", class DataStatistic extends HTMLElement {
      connectedCallback() {
        this.numberContent = this.querySelector("span");
        this._hasAnimated = false;
        this.min = parseInt(this.getAttribute("data-min") || "0", 10);
        this.max = parseInt(this.getAttribute("data-max") || "0", 10);
        this.duration = parseInt(this.getAttribute("data-duration") || "1500", 10);

        // Respect prefers-reduced-motion for accessibility and sets the final number directly
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion) {
          this.numberContent = this.formatNumber(this.max);
          return;
        }

        // Find the closest parent section
        const parentSection = this.closest("div.data-statistics");
        if (parentSection) {
          this._observer = new window.IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !this._hasAnimated) {
                  this._hasAnimated = true;
                  this.animateNumberCounter(this.min, this.max, this.duration);
                  observer.disconnect();
                }
              });
            },
            { threshold: 0.2 },
          );
          this._observer.observe(parentSection);
        } else {
          // Animate immediately if no parent section found
          this.animateNumberCounter(this.min, this.max, this.duration);
        }
      }

      formatNumber(num) {
        return num.toLocaleString();
      }

      animateNumberCounter(min, max, duration) {
        const start = +min;
        const end = +max;
        const range = end - start;
        const startTime = performance.now();
        const step = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const value = Math.floor(progress * range + start);
          this.numberContent.textContent = this.formatNumber(value);
          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            this.numberContent.textContent = this.formatNumber(end);
          }
        };
        requestAnimationFrame(step);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('show-more-button')) {
    customElements.define('show-more-button', class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
            nextElementToFocus.querySelector('input').focus()
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    // Reads the global subscribe()/PUB_SUB_EVENTS from pubsub.js/constants.js
  // (both plain global <script src> tags loaded in theme.liquid, not moved
  // into a javascript block) - safe since this only reads them, it
  // doesn't need to export anything back out of this closure.
  if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-Control-${ this.dataset.sectionId }`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
        this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
        this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (!this.checkboxInput.checked) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }

      clearInputFields() {
        this.emailInput.value = '';
        this.nameInput.value = '';
        this.messageInput.value = '';
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${ key }-error-${ this.dataset.sectionId }`
            const fieldSelector = `#Recipient-${ key }-${ this.dataset.sectionId }`;
            const placeholderElement = this.querySelector(`${fieldSelector}`);
            const label = placeholderElement?.getAttribute('placeholder') || key;
            const message = `${label} ${value}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message')
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = "error-message";
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach(field => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput].forEach(inputElement => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-accordion"] && !Shopify.designMode) return;
  try {
    // Guarded because this snippet can render many times on one page (once
  // per accordion instance) - javascript dedupes identical content
  // across renders, but this guard is cheap insurance against the
  // DOMContentLoaded/event listeners being wired up more than once.
  if (!window.__productAccordionInitialized) {
    window.__productAccordionInitialized = true;

    document.addEventListener("DOMContentLoaded", function () {
      initAccordions();
      window.addEventListener("resize", debounce(syncOpenHeights, 150), { passive: true });
    });

    document.addEventListener("product:refresh", function () {
      initAccordions();
    });

    document.addEventListener("accordion:init", (event) => {
      const accordion = event.detail?.accordion;
      if (accordion) {
        initAccordion(accordion);
      }
    });
  }

  function initAccordions() {
    const allAccordions = document.querySelectorAll(".product-accordion");
    allAccordions.forEach(initAccordion);
  }

  function initAccordion(accordionEl) {
    if (accordionEl.hasAttribute("data-accordion-initialized")) return;

    const header = accordionEl.querySelector(".product-accordion__header");
    const content = accordionEl.querySelector(".product-accordion__content");
    const icon = accordionEl.querySelector(".product-accordion__icon");
    const shouldOpen = accordionEl.dataset.open === "true";

    const expandContentbutton = accordionEl.querySelector("button.expand-content");
    const expandContent = accordionEl.querySelector(".expanded-content");

    if (shouldOpen) {
      content.style.maxHeight = content.scrollHeight + "px";
      header.setAttribute("aria-expanded", "true");
      if (icon) icon.classList.add("is-open");
    } else {
      content.style.maxHeight = 0;
      header.setAttribute("aria-expanded", "false");
      if (icon) icon.classList.remove("is-open");
    }

    header.addEventListener("click", function () {
      const isOpen = header.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        content.style.maxHeight = 0;
        if (icon) icon.classList.remove("is-open");
        header.setAttribute("aria-expanded", "false");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        if (icon) icon.classList.add("is-open");
        header.setAttribute("aria-expanded", "true");
      }
    });

    expandContentbutton?.addEventListener("click", function () {
      const isContentOpen = expandContent.getAttribute("aria-expanded") === "true";
      if (isContentOpen) {
        expandContent.classList.add("visually-hidden");
        expandContent.setAttribute("aria-expanded", "false");
        expandContent.setAttribute("data-open", "false");
        expandContentbutton.querySelector("span").innerHTML = expandContentbutton.getAttribute("data-readmore");

        syncOpenHeights();
      } else {
        expandContent.classList.remove("visually-hidden");
        expandContent.setAttribute("aria-expanded", "true");
        expandContent.setAttribute("data-open", "true");
        expandContentbutton.querySelector("span").innerHTML = expandContentbutton.getAttribute("data-readless");
        syncOpenHeights();
      }
    });

    accordionEl.setAttribute("data-accordion-initialized", "true");
  }

  function syncOpenHeights() {
    const contents = Array.from(
      document.querySelectorAll('.product-accordion .product-accordion__header[aria-expanded="true"]'),
      (header) => header.parentElement.querySelector(".product-accordion__content")
    ).filter(Boolean);

    // Read every height first, then write every style, so the browser only
    // needs to recalculate layout once instead of once per accordion.
    const heights = contents.map((content) => content.scrollHeight);
    contents.forEach((content, index) => {
      content.style.maxHeight = heights[index] + "px";
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-vertical"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carousel-slider')) {
    customElements.define('carousel-slider', class Carousel extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector(".js-carousel-slider");
        this.sliderId = this.id;
        this.enableSliderAutoplay = this.getAttribute("data-slider-autoplay") == "true" ? true : false;
        this.autoplaySpeed = this.getAttribute("data-slider-autoplay-speed") ? parseFloat(this.getAttribute("data-slider-autoplay-speed")) : 3000;
        this.prevButtons = this.querySelectorAll('button[name="previous"]');
        this.nextButtons = this.querySelectorAll('button[name="next"]');
        this.trackers = this.querySelectorAll(".js-carousel-tracker");
        this.dots = this.querySelectorAll(".js-carousel-dots");
        this.vertical = this.classList.contains("carousel--vertical") ? true : false;
        this.delayInit = this.getAttribute("data-delay-init") == "true" ? true : false;
        this.thumbSlider = this.getAttribute("data-slider-thumb") ? document.getElementById(this.getAttribute("data-slider-thumb")) : null;

        if (!this.slider) return;

        if (this.enableSliderAutoplay) this.autoplay();

        if (this.delayInit) {
          this.addEventListener("trigger-init", () => {
            this.initPages();
          });
        } else {
          this.initPages();
        }

        const resizeObserver = new ResizeObserver(() => this.initPages());
        resizeObserver.observe(this.slider);

        this.runTracker;
      }

      checkScreenSize() {
        if (window.innerWidth < 990 && this.classList.contains("carousel--vertical")) {
          this.vertical = false;
        }
        if (window.innerWidth > 991 && this.classList.contains("carousel--vertical")) {
          this.vertical = true;
        }
      }

      initPages() {
        this.checkScreenSize();
        this.sliderItems = this.querySelectorAll(`#${this.sliderId} > .js-carousel-slider > .js-carousel-slide`);
        this.slider.addEventListener("scroll", this.update.bind(this));
        if (this.prevButtons.length) {
          this.prevButtons.forEach((button) => {
            button.addEventListener("click", this.onButtonClick.bind(this));
          });
        }

        if (this.nextButtons.length) {
          this.nextButtons.forEach((button) => {
            button.addEventListener("click", this.onButtonClick.bind(this));
          });
        }

        if (this.getAttribute("data-slider-for")) {
          const mainSlider = document.getElementById(this.getAttribute("data-slider-for"));
          this.sliderItems.forEach((slide) => {
            slide.addEventListener("click", () => {
              this.sliderItems.forEach((item) => {
                item.classList.remove("active");
                item.querySelector(".thumbnail__button")?.removeAttribute("aria-current");
              });
              slide.classList.add("active");
              slide.querySelector(".thumbnail__button")?.setAttribute("aria-current", "true");
              mainSlider.scrollToSlide(slide.getAttribute("data-slide-index"));

              const status = this.parentElement.querySelector(".gallery-status");
              if (status && window.accessibilityStrings) {
                const position = parseInt(slide.getAttribute("data-slide-index"), 10) + 1;
                status.textContent = window.accessibilityStrings.imageAvailable.replace("[index]", position);
              }
            });
          });
        }

        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

        if (this.sliderItemsToShow[1] && this.sliderItemsToShow[0]) {
          if (this.vertical) {
            this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;

            this.slidesPerPage = Math.floor(this.slider.clientHeight / this.sliderItemOffset);
          } else {
            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
            this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset) + 1;
          }

          if (this.classList.contains("carousel--show-to-edge") || this.classList.contains("carousel--mini-cart") || this.classList.contains("carousel--complete-set") || this.classList.contains("carousel--predictive-search")) {
            this.slidesPerPage -= 1;
          }
          this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        }

        this.update();

        if (this.dots.length) {
          this.initDots();
        }

        if (this.vertical) {
          this.updateThumbButtons();
        }
      }

      update() {
        if (this.vertical) {
          this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
        } else {
          this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        }

        let currentSlide = this.currentPage;

        this.sliderItemsToShow.forEach((item, index) => {
          let thisSlide = index + 1;

          if (this.isSlideVisible(item) && thisSlide < currentSlide) {
            currentSlide = thisSlide;
          }
        });

        if (this.dots.length) {
          this.updateNextDot(currentSlide);
        }

        if (this.prevButtons.length) {
          if (this.isSlideVisible(this.sliderItemsToShow[0]) && !(this.currentPage > 1)) {
            this.prevButtons.forEach((button) => {
              button.setAttribute("disabled", "disabled");
            });
          } else {
            this.prevButtons.forEach((button) => {
              button.removeAttribute("disabled");
            });
          }
        }

        if (this.nextButtons.length) {
          if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) && !!this.sliderItemsToShow[this.sliderItemsToShow.length - 1].classList.contains("active")) {
            this.nextButtons.forEach((button) => {
              button.setAttribute("disabled", "disabled");
            });
          } else {
            this.nextButtons.forEach((button) => {
              button.removeAttribute("disabled");
            });
          }
        }

        if (this.trackers.length) {
          clearTimeout(this.runTracker);
          this.runTracker = setTimeout(() => {
            this.updateTracker();
          }, 50);
        }

        if (this.dots.length) {
          setTimeout(() => {
            this.updateDots(currentSlide);
          }, 250);
        }

        if (this.thumbSlider) {
          this.updateThumb(currentSlide);
        }
      }

      isSlideVisible(element, offset = 0) {
        if (element) {
          if (this.vertical) {
            const lastVisibleSlide = Math.ceil(this.slider.clientHeight + this.slider.scrollTop - offset);
            return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
          } else {
            const lastVisibleSlide = Math.ceil(this.slider.clientWidth + this.slider.scrollLeft - offset);
            return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
          }
        }
      }

      scrollToSlide(slide) {
        this.slideScrollPosition = slide * this.sliderItemOffset;
        if (this.vertical) {
          this.slider.scrollTo({
            top: this.slideScrollPosition,
          });
        } else {
          this.slider.scrollTo({
            left: this.slideScrollPosition,
          });
        }
      }

      initDots() {
        this.dots.forEach((dotElem) => {
          const allDots = dotElem.querySelectorAll("span");

          if (!allDots.length) {
            const dotMarkup = dotElem.classList.contains("js-carousel-timer")
              ? "<span><svg height='30' width='30'><circle class='circle' cx='15' cy='15' r='10'/></svg></span>"
              : "<span></span>";
            dotElem.innerHTML += dotMarkup.repeat(this.totalPages + 1);
          }

          for (let index = 0; index < allDots.length; index++) {
            if (index >= this.totalPages) {
              allDots[index].style.display = "none";
            } else if (index === this.totalPages - 1 && window.innerWidth > 1800 && (this.classList.contains("carousel--show-to-edge") || this.classList.contains("carousel--mini-cart") || this.classList.contains("carousel--complete-set") || this.classList.contains("carousel--predictive-search"))) {
              allDots[index].style.display = "none";
            } else {
              allDots[index].style.display = "block";
            }

            allDots[index].addEventListener("click", () => this.scrollToSlide(index));
          }
        });
      }

      updateNextDot(slide) {
        this.dots.forEach((dotElem) => {
          const allDots = dotElem.querySelectorAll("span");

          allDots.forEach((dot) => {
            dot.classList.remove("next");
          });

          if (allDots[slide - 1]) {
            allDots[slide - 1].classList.add("next");
          }
        });
      }

      updateDots(slide) {
        this.dots.forEach((dotElem) => {
          const allDots = dotElem.querySelectorAll("span");

          allDots.forEach((dot) => {
            dot.classList.remove("active");
          });

          if (allDots[slide - 1]) {
            allDots[slide - 1].classList.add("active");
          }
        });
      }

      updateTracker() {
        let lastSlideVisible = 0;
        this.sliderItemsToShow.forEach((item, index) => {
          if (this.isSlideVisible(item)) {
            lastSlideVisible = index + 1;
          }
        });

        let percentage = (lastSlideVisible / this.sliderItemsToShow.length) * 100;

        this.trackers.forEach((tracker) => {
          tracker.style.width = percentage + "%";
        });
      }

      onButtonClick(event, autoplay = false) {
        if (!autoplay) {
          event.stopImmediatePropagation();
          event.preventDefault();
        }

        const step = event?.currentTarget?.dataset?.step || 1;
        if (this.vertical) {
          this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollTop + step * this.sliderItemOffset : this.slider.scrollTop - step * this.sliderItemOffset;
        } else {
          this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) && event.currentTarget.name == "next") {
          if (this.vertical) {
            this.slider.scrollTo({
              top: 0,
            });
          } else {
            this.slider.scrollTo({
              left: 0,
            });
          }
        } else {
          if (this.vertical) {
            this.slider.scrollTo({
              top: this.slideScrollPosition,
            });
          } else {
            this.slider.scrollTo({
              left: this.slideScrollPosition,
            });
          }
        }
      }

      autoplay() {
        setInterval(() => {
          this.onButtonClick(
            {
              currentTarget: {
                name: "next",
              },
            },
            true,
          );
        }, this.autoplaySpeed);
      }

      updateThumb(slide) {
        if (typeof this.thumbSlider.scrollToSlide == "undefined") return;
        this.thumbSlider.scrollToSlide(slide - 1);
      }

      updateThumbButtons() {
        const isTouch = window.matchMedia("(max-width: 989px)").matches;
        const marginProperty = isTouch ? "marginLeft" : "marginTop";
        const marginValue = isTouch ? "16" : "8";

        if (this.sliderItemsToShow.length <= this.slidesPerPage) {
          this.sliderItems[0].style[marginProperty] = `${marginValue}px`;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-button"] && !Shopify.designMode) return;
  try {
    // ShareButton extends the globally-defined DetailsDisclosure class from
  // details-disclosure.js, which is loaded as a plain <script src> in
  // ua_header.liquid (not moved into a javascript block itself) - it
  // needs to remain a genuine global for this "extends" to resolve.
  if (!customElements.get('share-button')) {
    customElements.define('share-button', class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input')
        }
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_carousel_recommendations"] && !Shopify.designMode) return;
  try {
    // javascript content is wrapped in its own closure by Shopify, so a
  // plain top-level function here would NOT be reachable from the
  // onclick="switchView(...)" attributes below (those look it up on
  // window). Assigning it to window explicitly keeps it callable from
  // inline HTML attributes without changing the markup.
  window.switchView = function switchView(self, view) {
    const carousel = self.closest('.carousel');
    const recommendationsTab = carousel.querySelector('.product-recommendations-tab');
    const recentlyTab = carousel.querySelector('.recently-viewed-tab');
    const recommendations = carousel.querySelector('product-recommendations');
    const recently = carousel.querySelector('recently-viewed');
    const activeTab = carousel.querySelector('.' + view + '-tab');
    const activeElement = carousel.querySelector(view);

    // Clear active class
    if (recommendationsTab) { recommendationsTab.classList.remove('active'); }
    if (recentlyTab) { recentlyTab.classList.remove('active'); }
    if (recommendations) { recommendations.classList.remove('active'); }
    if (recently) { recently.classList.remove('active'); }

    // Add active classes
    if (activeTab) { activeTab.classList.add('active'); }
    if (activeElement) { activeElement.classList.add('active'); }
  };

  // Runs once per carousel instance on the page - values that used to be
  // baked into this script via Liquid interpolation (not supported inside
  // this tag) now come from data attributes on the instance's own root
  // element instead.
  document.querySelectorAll('.carousel[data-hide-recommendations-carousel]').forEach((carouselSection) => {
    const productHandlesList = localStorage.getItem("shopify_recently_viewed");
    const recentlyViewedTab = carouselSection.querySelector('.recently-viewed-tab');
    const recentlyViewed = carouselSection.querySelector('recently-viewed');

    const bothUnchecked = carouselSection.dataset.bothUnchecked === 'true';
    const hideRecommendationsCarousel = carouselSection.dataset.hideRecommendationsCarousel === 'true';
    const hideRecentlyTab = carouselSection.dataset.hideRecentlyTab === 'true';
    const productHandle = carouselSection.dataset.productHandle;
    const noRecentlyViewed = !productHandlesList || productHandlesList === "" || productHandlesList === productHandle;

    // Hide all?
    if (bothUnchecked || (hideRecommendationsCarousel && noRecentlyViewed)) {
      carouselSection.classList.add('hidden');
    }

    // Hide recently?
    if (!hideRecentlyTab && noRecentlyViewed) {
      recentlyViewedTab?.classList.add('hidden');
      recentlyViewed?.classList.add('hidden');
    }
  });

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector("product-recommendations");

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                this.remove();
              }

              // Number of cards loaded will be cards.length
              const cards = html.querySelectorAll(".grid__item");

              // When the section is re-loaded with products, liquid within cannot reach the outer feature wrap element
              // Need to add fit-exactly classes with js depending on how many products are loaded
              // With the extra class a width for showing an extra quarter or half overrides the exact fit width
              const feature_card_enabled = this.dataset.feature_card_enabled === "true";
              if (feature_card_enabled) {
                const columns_desktop = parseInt(this.dataset.columns_desktop);
                const cards_fit_desktop = cards.length <= columns_desktop;
                const feature_wrap_el = document.querySelector(`#shopify-section-${this.dataset.section_id} .carousel__feature-wrap`);
                if (cards_fit_desktop) {
                  feature_wrap_el.classList.add("carousel__feature-wrap--cards-fit-desktop");
                }
              }

              const parent_section = document.getElementById(this.dataset.section_id);

              // Need to check recently tab before hiding the whole thing
              const hide_recently_tab = this.dataset.hide_recently_tab === "true";
              const product_handle = this.dataset.product_handle;
              const product_handles_list = localStorage.getItem("shopify_recently_viewed");
              const no_recently_viewed = !product_handles_list || product_handles_list == "" || product_handles_list == product_handle;

              if (cards) {
                // Loaded
                this.classList.add("product-recommendations--loaded");
              } else if (hide_recently_tab || no_recently_viewed) {
                // No items - recently not showing - hide the carousel
                if (parent_section) {
                  parent_section.classList.add("hidden");
                }
              } else {
                // hide just product recommendations
                // hide both tabs
                const recommendations = parent_section.querySelector("product-recommendations");
                const recently = parent_section.querySelector("recently-viewed");
                const recommendations_tab = parent_section.querySelector(".product-recommendations-tab");
                const recently_tab = parent_section.querySelector(".recently-viewed-tab");

                recommendations_tab.classList.add("hidden");
                recently_tab.classList.add("hidden");
                recommendations.classList.remove("active");
                recently.classList.add("active");
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
    });
  }

  if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
      }

      config = {
        maxToShow: parseInt(this.dataset.max_cards_to_output),
        minToShow: 1,
        howManyToStoreInMemory: parseInt(this.dataset.max_cards_to_output),
        numberProducts: 0,
        onComplete: null,
      };
      productHandleQueue = [];

      cookie = {
        name: "shopify_recently_viewed",
        write: function (recentlyViewed) {
          localStorage.setItem(this.name, recentlyViewed.join(","));
        },
        read: function () {
          let recentlyViewed = [];
          let cookieValue = localStorage.getItem(this.name);
          if (cookieValue) {
            recentlyViewed = cookieValue.split(",");
          }
          return recentlyViewed;
        },
        destroy: function () {
          localStorage.removeItem(this.name);
        },
        remove: function (productHandle) {
          let recentlyViewed = this.read();
          let position = recentlyViewed.indexOf(productHandle);
          if (position !== -1) {
            recentlyViewed.splice(position, 1);
            this.write(recentlyViewed);
          }
        },
      };

      finalize = () => {
        // Add and remove classes that depend on the number of cards

        // Get elements
        const sliderComponent = this.querySelector("slider-component");
        const sliderUL = this.querySelector("slider-component ul.slider");
        const featureWrap = document.querySelector(`#shopify-section-${this.dataset.section_id}.carousel__feature-wrap`);
        const max_cards_to_output = this.config.maxToShow;

        // Hide buttons if cards fit
        const columns_desktop = parseInt(this.dataset.columns_desktop);
        const columns_mobile = parseInt(this.dataset.columns_mobile);
        let cards_fit_desktop = sliderUL.children.length <= columns_desktop;
        const cards_fit_mobile = sliderUL.children.length <= columns_mobile;
        const feature_card_enabled = this.dataset.feature_card_enabled === "true";
        if (feature_card_enabled) {
          cards_fit_desktop = sliderUL.children.length < columns_desktop;
        } else {
          cards_fit_desktop = sliderUL.children.length <= columns_desktop;
        }

        if (cards_fit_desktop) {
          sliderComponent.classList.add("slider-component--cards-fit-desktop");
        } else {
          sliderComponent.classList.remove("slider-component--cards-fit-desktop");
        }

        if (cards_fit_mobile) {
          sliderComponent.classList.add("slider-component--cards-fit-mobile");
        } else {
          sliderComponent.classList.remove("slider-component--cards-fit-mobile");
        }

        if (featureWrap) {
          if (cards_fit_desktop) {
            featureWrap.classList.add("carousel__feature-wrap--cards-fit-desktop");
          } else {
            featureWrap.classList.remove("carousel__feature-wrap--cards-fit-desktop");
          }
        }

        if (this.dataset.full_width === "true") {
          // set full_width class on parent
          sliderComponent.classList.add("slider-component-full-width");
          sliderComponent.classList.remove("page-width");
        } else {
          sliderComponent.classList.remove("slider-component-full-width");
          sliderComponent.classList.add("page-width");
        }

        sliderUL.scrollLeft = 0;
        this.classList.add("recently-viewed--loaded");
      };

      getRecentProducts = async () => {
        let searchRecentlyUrl;
        let productHandle;

        if (window.location.pathname.indexOf("/products/") !== -1) {
          productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
          this.productHandleQueue = this.productHandleQueue.filter((handle) => productHandle !== handle);
        }

        if (this.productHandleQueue.length < this.config.minToShow) {
          return;
        }
        this.config.numberProducts = this.productHandleQueue.length;

        this.productHandleQueue.length = this.config.maxToShow;
        searchRecentlyUrl = "/search?view=ua_recently-viewed&q=" + this.productHandleQueue.toString();
        await fetch(searchRecentlyUrl)
          .then((response) => response.text())
          .then((html) => {
            document.querySelector(`#shopify-section-${this.dataset.sectionid} recently-viewed`).innerHTML = html;
            this.finalize();
          })
          .catch((err) => {
            console.warn("Something went wrong.", err);
          });
      };

      recordRecentlyViewed = (values) => {
        let vals = values || {};
        let recentlyViewed = this.cookie.read();
        let productHandle;
        let position;

        // Update defaults.
        this.config = { ...this.config, ...vals };

        // If we are on a product page.
        if (window.location.pathname.indexOf("/products/") !== -1) {
          productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];

          position = recentlyViewed.indexOf(productHandle);

          if (position === -1) {
            recentlyViewed.unshift(productHandle);

            recentlyViewed = recentlyViewed.splice(0, this.config.howManyToStoreInMemory);
          } else {
            recentlyViewed.splice(position, 1);
            recentlyViewed.unshift(productHandle);
          }

          this.cookie.write(recentlyViewed);
        }
      };

      showRecentlyViewed = (parameters) => {
        // Hide whole carousel if only tab and nothing to show
        const recently_is_only_tab = this.dataset.recently_is_only_tab === "true";
        const sectionid = this.dataset.section_id;
        const carousel = document.querySelector(".carousel.section-" + sectionid);
        const product_handles_list = localStorage.getItem("shopify_recently_viewed");
        if (this.dataset.on_product_page === "true") {
          const product_handle = this.dataset.product_handle;
          const no_recently_viewed = !product_handles_list || product_handles_list == "" || product_handles_list == product_handle;
          if (recently_is_only_tab && no_recently_viewed && carousel) {
            carousel.classList.add("hidden");
          } else {
            const no_recently_viewed = !product_handles_list || product_handles_list == "";
            if (recently_is_only_tab && no_recently_viewed && carousel) {
              carousel.classList.add("hidden");
            }
          }
        }

        let params = parameters || {};
        // Update defaults.
        this.config = { ...this.config, ...params };

        // Read cookie.
        this.productHandleQueue = this.cookie.read();

        if (this.productHandleQueue === null || this.productHandleQueue === undefined) {
          return false;
        }

        this.config.maxToShow = Math.min(this.productHandleQueue.length, this.config.maxToShow);

        if (this.config.maxToShow) {
          this.getRecentProducts().then();
        }
      };

      connectedCallback() {
        this.showRecentlyViewed();
        this.recordRecentlyViewed();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_cart-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('upsell-product-recommendations')) {
    customElements.define('upsell-product-recommendations', class UpsellProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("upsell-product-recommendations");

            if (recommendations) {
              if (recommendations.innerHTML.trim().length == 0) {
                fetch(this.dataset.fallbackurl)
                  .then((response) => response.text())
                  .then((text) => {
                    html.innerHTML = text;
                    const recommendations = html.querySelector("upsell-product-recommendations");
                    this.innerHTML = recommendations.innerHTML;
                    if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                      this.remove();
                    }
                    if (html.querySelector(".grid__item")) {
                      this.classList.add("product-recommendations--loaded");
                    }
                  });
              } else {
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                  this.remove();
                }
                if (html.querySelector(".grid__item")) {
                  this.classList.add("product-recommendations--loaded");
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    });
  }

  if (!customElements.get('crossell-product-recommendations')) {
    customElements.define('crossell-product-recommendations', class CrossellProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("crossell-product-recommendations");

            if (recommendations) {
              if (recommendations.innerHTML.trim().length == 0) {
                fetch(this.dataset.fallbackurl)
                  .then((response) => response.text())
                  .then((text) => {
                    html.innerHTML = text;
                    const recommendations = html.querySelector("crossell-product-recommendations");
                    this.innerHTML = recommendations.innerHTML;
                    if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                      this.remove();
                    }
                    if (html.querySelector(".grid__item")) {
                      this.classList.add("product-recommendations--loaded");
                    }
                  });
              } else {
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                  this.remove();
                }
                if (html.querySelector(".grid__item")) {
                  this.classList.add("product-recommendations--loaded");
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    });
  }

  if (!customElements.get('recently-viewed-product-recommendations')) {
    customElements.define('recently-viewed-product-recommendations', class RecentlyViewedProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Retrieve recently viewed product handles from localStorage
        const recentlyViewedHandles = localStorage.getItem("shopify_recently_viewed");

        if (recentlyViewedHandles) {
          const productHandles = recentlyViewedHandles.split(",").slice(0, 3); // Limit to 5 products

          // Use the Sections Rendering API to fetch the product-card section
          const sectionUrl = "/search?view=ua_recently-viewed-grid&q=" + productHandles.toString();
          fetch(sectionUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Failed to fetch recently viewed section: ${response.statusText}`);
              }
              return response.text();
            })
            .then((html) => {
              // Insert the fetched HTML into the component
              this.innerHTML = html;
              this.classList.add("product-recommendations--loaded");
            })
            .catch((error) => {
              console.error("Error fetching recently viewed products:", error);
              this.loadFallback(); // Load fallback if the API call fails
            });
        } else {
          // If no recently viewed products, fallback to the fallback URL
          this.loadFallback();
        }
      }

      loadFallback() {
        // Fetch fallback recommendations if no recently viewed products are available
        fetch(this.dataset.fallbackurl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Failed to fetch fallback recommendations: ${response.statusText}`);
            }
            return response.text();
          })
          .then((html) => {
            this.innerHTML = html;
            this.classList.add("product-recommendations--loaded");
          })
          .catch((error) => {
            console.error("Error loading fallback recommendations:", error);
          });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_collection-layout-toggle"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get("layout-toggle")) {
    window.customElements.define("layout-toggle", class GridToggle extends HTMLElement {
      constructor() {
        super();
        this.expandedGridViewButton = this.querySelector('#expandedGridViewButton');
        this.standardGridViewButton = this.querySelector('#standardGridViewButton');
        this.smallGridViewButton = this.querySelector('#smallGridViewButton');

        this.expandedGridViewButton?.addEventListener('click', this.onButtonClick.bind(this));
        this.standardGridViewButton?.addEventListener('click', this.onButtonClick.bind(this));
        this.smallGridViewButton?.addEventListener('click', this.onButtonClick.bind(this));

        const gridView = localStorage.getItem("layout-grid-option");

        if(gridView == "expanded-grid") {
          this.expandedGridViewButton.click();
        } else if (gridView == "standard-grid") {
          this.standardGridViewButton.click();
        } else if (gridView == "small-grid") {
          this.smallGridViewButton.click();
        }
      }

      onButtonClick(event) {
        event.preventDefault();
        const colID = event.currentTarget.id;
        if (colID == 'expandedGridViewButton') {

          const expandedGridViewButton = document.querySelectorAll('#expandedGridViewButton');
          const standardGridViewButton = document.querySelectorAll('#standardGridViewButton');
          const smallGridViewButton = document.querySelectorAll('#smallGridViewButton');

          expandedGridViewButton.forEach((element) => {
            document.getElementById('ProductGridContainer').classList.add('grid-large-view');
            document.getElementById('ProductGridContainer').classList.remove('grid-regular-view');
            document.getElementById('ProductGridContainer').classList.remove('grid-small-view');

            element.classList.add('active');
          });

          standardGridViewButton.forEach((element) => {
            element.classList.remove('active');
          });

          smallGridViewButton.forEach((element) => {
            element.classList.remove('active');
          });

          localStorage.setItem("layout-grid-option", "expanded-grid");


        } else if (colID == 'standardGridViewButton') {
          const expandedGridViewButton = document.querySelectorAll('#expandedGridViewButton');
          const standardGridViewButton = document.querySelectorAll('#standardGridViewButton');
          const smallGridViewButton = document.querySelectorAll('#smallGridViewButton');

          standardGridViewButton.forEach((element) => {
            document.getElementById('ProductGridContainer').classList.remove('grid-large-view');
            document.getElementById('ProductGridContainer').classList.add('grid-regular-view');
            document.getElementById('ProductGridContainer').classList.remove('grid-small-view');

            element.classList.add('active');
          });

          expandedGridViewButton.forEach((element) => {
            element.classList.remove('active');
          });

          smallGridViewButton.forEach((element) => {
            element.classList.remove('active');
          });

          localStorage.setItem("layout-grid-option", "standard-grid");

        } else if (colID == 'smallGridViewButton') {

          const expandedGridViewButton = document.querySelectorAll('#expandedGridViewButton');
          const standardGridViewButton = document.querySelectorAll('#standardGridViewButton');
          const smallGridViewButton = document.querySelectorAll('#smallGridViewButton');

          smallGridViewButton.forEach((element) => {
            document.getElementById('ProductGridContainer').classList.remove('grid-large-view');
            document.getElementById('ProductGridContainer').classList.remove('grid-regular-view');
            document.getElementById('ProductGridContainer').classList.add('grid-small-view');

            element.classList.add('active');
          });

          expandedGridViewButton.forEach((element) => {
            element.classList.remove('active');
          });

          standardGridViewButton.forEach((element) => {
            element.classList.remove('active');
          });

          localStorage.setItem("layout-grid-option", "small-grid");
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_free-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('progress-bar')) {
    customElements.define('progress-bar', class ProgressBar extends HTMLElement {
      constructor() {
        super();

        this.progress = parseInt(this.dataset.value);
      }
    });
  }

  if (!customElements.get('free-shipping')) {
    customElements.define('free-shipping', class FreeShipping extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.cartTotal = this.dataset.cartTotal ? this.dataset.cartTotal : 0;
        this.freeShippingThreshold = this.dataset.freeShippingThreshold ? this.dataset.freeShippingThreshold : 0;
        this.message = this.dataset.message ? this.dataset.message : 0;
        this.currencySymbol = this.dataset.currencySymbol ? this.dataset.currencySymbol : 0;
        this.roundAmount = this.dataset.roundAmount ? this.dataset.roundAmount : false;
        this.amountLeftToSpend = this.getAmountLeft();
        this.messageWrapper = this.querySelector('span');

        this.shippingLink = this.dataset.shippingLink ? this.dataset.shippingLink : '';
        this.shippingLinkTitle = this.dataset.shippingLinktitle ? this.dataset.shippingLinktitle : '';
        this.formattedShippingLink = '';

        if (this.shippingLink) {
          this.formattedShippingLink = `<a target="_blank" href="${this.shippingLink}">${this.shippingLinkTitle}</a>`;
        }

        this.setMessage();
        this.addMessage();
      }
      disconnectedCallback() {
        if (this.querySelector('p')) {
          this.querySelector('p').remove();
        }
      }
      getAmountLeft() {
        let currencyRate = 1; // Shopify.currency.rate;

        let amountLeftToSpend = (this.freeShippingThreshold - this.cartTotal * currencyRate * 1) / 100;
        amountLeftToSpend = Math.round(amountLeftToSpend * 100) / 100;
        amountLeftToSpend = this.roundAmount ? Math.round(amountLeftToSpend) : amountLeftToSpend;
        amountLeftToSpend = amountLeftToSpend.toFixed(2);

        return amountLeftToSpend <= 0 ? 0 : this.currencySymbol + amountLeftToSpend;
      }
      setMessage() {
        this.message = this.message.replace('{{ amount }}', this.amountLeftToSpend);
        this.message = this.message.replace('{{ link }}', this.formattedShippingLink);
      }
      addMessage() {
        const node = document.createElement('p');
        node.innerHTML = this.message;
        this.messageWrapper.append(node);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_pagination"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('progress-bar')) {
    customElements.define('progress-bar', class ProgressBar extends HTMLElement {
      constructor() {
        super();

        this.progress = parseInt(this.dataset.value);
      }
    });
  }

  if (!customElements.get('loading-button')) {
    customElements.define('loading-button', class loadingButton extends HTMLElement {
      constructor() {
        super();
        this.url = document.querySelector(".pagination-wrapper a.pagination__item--next").href;
        this.totalProducts = 0;
        this.loadedProducts = 0;
        this.progressBar = this.querySelector(".progress-bar");
        this.progressBar.value = this.loadedProducts;
        this.resultCount = this.querySelector(".result-count");
        this.resultCountCollectionHead = document.querySelector(".product-count-vertical .result-count");
        this.automaticLoading = this.getAttribute("automatic-loading");
        this.loadButtonContainer = this.closest(".pagination-wrapper");
        this.loadButton = this.querySelector("button");
        this.productContainer = document.querySelector("#product-grid");
        this.articleContainer = document.querySelector("#article-grid");
        this.vanillaPagination = document.querySelector("#pagination");
        this.loadButton.addEventListener("click", this.loadMore.bind(this));
        this.resultType = "products";

        if (this.url.includes("blog")) {
          this.resultType = "articles";
        }

        // loading observer
        let options = {
          root: null,
          rootMargin: "0px",
          threshold: 0.25,
        };
        this.observer = new IntersectionObserver(this.handleIntersection, options);
      }

      connectedCallback() {
        if (this.automaticLoading === "true") {
          this.observer.observe(this.loadButton);
        }
        this.loadedProducts = parseInt(this.loadButton.getAttribute("data-loaded-products-total"));
        this.totalProducts = parseInt(this.loadButton.getAttribute("data-total-results-count"));
        this.updateProgress();
      }

      handleIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            entry.target.closest("loading-button").loadMore();
          }
        });
      }

      loadMore() {
        this.url = document.querySelector(".pagination-wrapper a.pagination__item--next").href;
        this.loadButton.classList.add("loading");
        this.loadButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        this.fetchItems(this.url);
      }

      fetchItems(url) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            if (url.includes("blog")) this.renderArticleGrid(html);
            else this.renderProductGrid(html);
            this.renderNewNavigation(html);
            this.loadingButtonChecker();
            this.updateProgress();
          });
      }

      renderProductGrid(html) {
        let newPage = new DOMParser().parseFromString(html, "text/html").getElementById("product-grid").innerHTML;
        this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
        this.loadedProducts = this.productContainer.querySelectorAll(".product").length;
      }

      renderArticleGrid(html) {
        this.resultType = "articles";
        let newPage = new DOMParser().parseFromString(html, "text/html").getElementById("article-grid").innerHTML;
        this.articleContainer.innerHTML = this.articleContainer.innerHTML + newPage;
        this.loadedArticles = this.articleContainer.querySelectorAll(".article").length;
      }

      renderNewNavigation(html) {
        this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("pagination").innerHTML;
      }

      loadingButtonChecker() {
        this.loadButton.classList.remove("loading");
        this.loadButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
        if (document.querySelectorAll(".pagination-wrapper a.pagination__item--next").length === 0) {
          this.loadButtonContainer.classList.add("hidden");
        }
      }

      updateProgress() {
        let progress = (this.loadedProducts / this.totalProducts) * 100;
        this.progressBar.setAttribute("style", "--progress:" + `${progress}` + "%");

        // Use the translation strings from theme.liquid
        if (window.paginationStrings) {
          const templateKey = this.resultType === 'products' ? 'showingProducts' : 'showingArticles';
          const translatedText = window.paginationStrings[templateKey]
            .replace('[loaded]', this.loadedProducts)
            .replace('[total]', this.totalProducts);

          if (this.resultCount) {
            this.resultCount.textContent = translatedText;
          }
          if (this.resultCountCollectionHead) {
            this.resultCountCollectionHead.textContent = translatedText;
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("sticky-atc")) {
    class StickyATC extends HTMLElement {
      constructor() {
        super({
          name: "Sticky ATC",
          version: "2.0.0",
        });
      }

      connectedCallback() {
        this.stickyATCUpper = document.querySelector(".section-main-product");

        if (!this.stickyATCUpper) return;

        this.button = this.querySelector("[data-sticky-atc-btn]");

        document.documentElement.style.setProperty("--footer-offset", `${this.offsetHeight}px`);

        new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.3 }).observe(this.stickyATCUpper);

        this.button.addEventListener("click", this.onClickHandler.bind(this));
      }

      disconnectedCallback() {
        if (!this.stickyATCUpper) return;

        // disconnect IntersectionObserver
        const observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.3 });
        observer.unobserve(this.stickyATCUpper);
      }

      handleUpperIntersect(entries, observer) {
        this.colorSelector = this.querySelector(".product__color-selector");
        this.variantSelector = this.querySelector(".product__variant-selector");

        entries.forEach((entry) => {

          const scrolledPastTop = entry.boundingClientRect.top < 0;

          const stickyATC = document.querySelector('sticky-atc');

          if (!entry.isIntersecting && scrolledPastTop) {
              stickyATC.style.transform = 'translateY(0)';
              stickyATC.removeAttribute('aria-hidden');
              stickyATC.removeAttribute('inert');
              document.body.classList.add('sticky-atc-visible');
          } else {
            stickyATC.style.transform = 'translateY(calc(100% + var(--space-24)))';
            stickyATC.setAttribute('aria-hidden', 'true');
            stickyATC.setAttribute('inert', '');
            document.body.classList.remove('sticky-atc-visible');
          }
        });

      }

      onClickHandler(event) {
        event.preventDefault();

        const target = document.querySelector(".buy-block-wrapper");
        if (!target) return;

        const rect = target.getBoundingClientRect();

        const scrollTop = window.pageYOffset;
        const elementBottom = rect.bottom + scrollTop;

        const viewportHeight = window.innerHeight;

        const offset = 20;

        const targetScroll = elementBottom - viewportHeight + offset;

        window.scrollTo({
          top: targetScroll,
          behavior: "smooth",
        });
      }
    }

    customElements.define("sticky-atc", StickyATC);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ua_video-loader"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-loader')) {
    customElements.define(
      'video-loader',
      class VideoLoader extends HTMLElement {
        constructor() {
          super();
          this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
            root: null, // Use the viewport as the root
            threshold: 0.5, // Trigger when 50% of the element is visible
          });

          this.videoId = this.getAttribute('id');
          this.videoTrigger = document.querySelector(`[data-video="#` + this.videoId + `"]`);
        }

        connectedCallback() {
          this.observeVideos();
        }

        // Define a function to observe videos within the custom element and load them when they become visible
        observeVideos() {
          const videos = this.querySelectorAll('video');

          videos.forEach((video) => {
            this.intersectionObserver.observe(video);

            video.setAttribute('data-paused', 'false');

            video.addEventListener('pause', (event) => {
              video.setAttribute('data-paused', 'true');
            });
          });
        }

        // Handle the intersection changes (when videos become visible/invisible)
        handleIntersection(entries, observer) {
          entries.forEach((entry) => {
            const video = entry.target;

            if (entry.isIntersecting) {
              const sources = video.querySelectorAll('source[data-src]');

              sources.forEach((source) => {
                source.src = source.getAttribute('data-src');
              });

              if (video.getAttribute('data-paused') == 'false') {
                video.load();
              } else {
                if (entry.target.getAttribute('autoplay') === 'autoplay') {
                  video.setAttribute('data-paused', 'false');
                  video.play();
                }
              }

              video.onloadeddata = function () {
                if (entry.target.getAttribute('autoplay') === 'autoplay') {
                  video.setAttribute('data-paused', 'false');
                  video.play();
                }
              };
              // Unobserve the video once it's loaded
              // observer.unobserve(video);
            } else {
              video.pause();
            }
          });
        }

        // Clean up the Intersection Observer when the element is removed from the DOM
        disconnectedCallback() {
          this.intersectionObserver.disconnect();
        }
      }
    );
  }

  if (!customElements.get('video-trigger')) {
    customElements.define('video-trigger', class VideoTrigger extends HTMLElement {
      constructor() {
        super();

        this.video = document.querySelector(this.dataset.video);

        this.addEventListener("click", () => {
          this.playVideo();

          if (this.dataset.hide != null) {
            this.hideContent();
          }
        });
      }

      playVideo() {
        const mediaQuery = window.matchMedia("(min-width: 550px)");

        let video;

        if (mediaQuery.matches) {
          video = this.video.querySelector("[data-desktop-video] video");
        } else {
          video = this.video.querySelector("[data-mobile-video] video");
        }

        if (!video) return;

        if (!this.classList.contains("is-playing")) {
          video.play();
          video.setAttribute("data-paused", "false");
        } else {
          video.pause();
          video.setAttribute("data-paused", "true");
        }

        video.addEventListener("ended", this.toggleState.bind(this));

        this.toggleState();
      }

      toggleState() {
        const playIcon = this.querySelector(".icon-play");
        const pauseIcon = this.querySelector(".icon-pause");

        if (!playIcon && !pauseIcon) return;

        this.classList.toggle("is-playing");

        if (this.classList.contains("is-playing")) {
          pauseIcon.classList.toggle("hidden");
          playIcon.classList.toggle("hidden");
          this.querySelector("b").innerText = window.videoControls.pause;
          this.setAttribute("aria-label", window.videoControls.pause);
        } else {
          pauseIcon.classList.add("hidden");
          playIcon.classList.remove("hidden");
          this.querySelector("b").innerText = window.videoControls.play;
          this.setAttribute("aria-label", window.videoControls.play);
        }
      }

      hideContent() {
        const contentToHide = document.querySelector(this.dataset.hide);
        contentToHide.classList.add("hidden");
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
